import './Alumni.css';
import Alasca from "./Partials/Alasca";
import Topper from "./Partials/Topper";
import Gallery from "./Partials/Gallery";
import Contact from "./Partials/Contact";
import Members from "./Partials/Members";
import LatestNews from "./Partials/LatestNews";
import DynamicBanner from "./Partials/DynamicBanner";

const Alumni = () => {
  return (
    <div className="alumni-page">
      <DynamicBanner />
      <Alasca />
      <Topper />
      <Members />
      <LatestNews/>
      <Gallery/>
      <Contact/>
    </div>
  )
}

export default Alumni;